<ub-button-list>
  <ng-container>
    @if (workflowId !== null) {
      <button mat-stroked-button color="accent" type="button" (click)="onEdit(workflowId)" i18n>Edit this workflow</button>
      <button mat-stroked-button color="accent" type="button" (click)="onDuplicate(workflowId)" i18n>Duplicate this workflow</button>
    }
  </ng-container>
  <button mat-flat-button color="accent" type="button" (click)="onCreate()" i18n>Create new workflow</button>
</ub-button-list>
